import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import Experimentation from '#client/components/Experimentation';
import { DB_APPLICATION_STATUS, SHOW_AB_TEST } from '#client/constants/application';
import { RELEASE_BANKING_UPSELL_PAGE_AND_NON_QUALIFIED_PAGE_TO_INCLUDE_BLUEVINE as OFFER_FLAG } from '#client/constants/experimentsFlags';
import { BANKING_ELIGIBILITY_STATUS } from '#client/constants/validationMessages';
import useApplicationStatusContext from '#client/hooks/useApplicationStatusContext';
import useBankingEligibilityCheck from '#client/hooks/useBankingEligibilityCheck';
import useOrderTaskContext from '#client/hooks/useOrderTaskContext';

import Dashboard from './DashboardContainer';
import BusinessBankingAccounts from '../BussinessBankingAccounts';

const ABTestRedirectContainer = () => {
  const offerVariation = useExperimentFlag(OFFER_FLAG.FLAG, OFFER_FLAG.VARIATIONS.CONTROL);
  const { appStatus } = useApplicationStatusContext();

  // appStatus is not undefined on the first render, so we don't have to "hold" for this value
  const shouldCheckElegibility = appStatus !== DB_APPLICATION_STATUS.APPROVED;

  const { bankingPreferredTask } = useOrderTaskContext();
  const { bankingEligibilityStatus, isCheckingEligibleBankingApplication } =
    useBankingEligibilityCheck({
      isSkip: !bankingPreferredTask || !shouldCheckElegibility
    });

  const shouldShowNewUpsell =
    offerVariation !== OFFER_FLAG.VARIATIONS.CONTROL &&
    (!bankingPreferredTask ||
      bankingPreferredTask?.status === DB_APPLICATION_STATUS.CANCELED ||
      bankingEligibilityStatus === BANKING_ELIGIBILITY_STATUS.BANKING_ORDER_DECLINED);

  if (!appStatus || isCheckingEligibleBankingApplication) {
    return <div />;
  }

  if (SHOW_AB_TEST.includes(appStatus)) {
    return shouldShowNewUpsell ? <BusinessBankingAccounts /> : <Experimentation />;
  }
  // Version B is just the original dashboard with a pop-up modal
  return <Dashboard />;
};

export default ABTestRedirectContainer;
